// Shipping inputs are gross. Match the server's cent allocation by VAT rate.
export function shippingVat(gross, items, country) {
  if (String(country).toUpperCase() !== 'CH') return [];
  const groups = new Map();
  items.forEach(({vat, total}) => {
    if (Number(total) > 0) groups.set(Number(vat), (groups.get(Number(vat)) || 0) + Number(total));
  });
  const entries = [...groups.entries()].sort((a, b) => a[0] - b[0]);
  const weight = entries.reduce((sum, row) => sum + row[1], 0);
  const cents = Math.round(Number(gross || 0) * 100);
  if (!weight || !cents) return [];
  let allocated = 0;
  return entries.map(([percentage, value], index) => {
    const share = index === entries.length - 1 ? cents - allocated : Math.round(cents * value / weight);
    allocated += share;
    const vat = Math.round(share - share / (1 + percentage / 100));
    return {percentage, total: (share - vat) / 100, vat: vat / 100, gross: share / 100};
  });
}
